import React from "react";
import DocumentCard from "../components/DocumentCard";

const projects = [
  {
    id: 1,
    name: "PNRAS",
    image: process.env.PUBLIC_URL + "/logoProiecte/PNRAS.jpeg",
    linkType: "page",
    link: "/proiecte/PNRAS",
  },
  {
    id: 2,
    name: "SmartLab",
    image: process.env.PUBLIC_URL + "/logoProiecte/SmartLab.jpg",
    linkType: "page",
    link: "/proiecte/SmartLab",
  },
  {
    id: 3,
    name: "Erasmus +",
    image: process.env.PUBLIC_URL + "/logoProiecte/Erasmus+.png",
    linkType: "page",
    link: "/proiecte/Erasmus+",
  },
  {
    id: 4,
    name: "Săptămâna meseriilor",
    image: process.env.PUBLIC_URL + "/logoProiecte/sapt_meseriilor.png",
    linkType: "page",
    link: "/proiecte/saptamana-meseriilor",
  },
  {
    id: 5,
    name: "Activități extracurriculare",
    image: process.env.PUBLIC_URL + "/logoProiecte/ActivitatiExtracurriculare.png",
    linkType: "page",
    link: "/programe/activitati",
  }
];

function ProiectePage() {
  return (
    <div>
      <div
        style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
      >
        {projects.map((project) => (
          <DocumentCard key={project.id} {...project} />
        ))}
      </div>
    </div>
  );
}

export default ProiectePage;
